import React from "react";
function WorkCard ({ item }) {
  return (
    <div className="p-8 w-full md:w-[45%] mt-4 flex justify-between items-center flex-col md:flex-row-reverse shadow-md">
      <img src={item.companyLogo} className=" h-20 mb-5" alt="" />
      <div className="flex flex-start flex-col mr-2 mb-3">
        <label className="text-xl font-semibold">{item.company}</label>
        <div className="text-red-800 flex flex-row-reverse justify-between">
          <div><label>{item.dateJoining}</label>-<label>{item.dateEnd}</label></div>
          <label className="text-sm font-semibold">{item.designation}</label>
        </div>
        <div className="text-left block max-w-[80%]">
          <p>{item.work}</p>
        </div>
      </div>
    </div>
  );
}

export default WorkCard;